import React, { FC } from 'react'
import { addUrlParams } from 'Pages/landings/newLandings/common/helpers'
import { useAdriverPixel } from 'Pages/landings/newLandings/common/hooks'
import {
	LandingNames,
	ProductNames,
	AdMarkErid,
	EridParam,
} from 'Pages/landings/newLandings/common/constants'
import rboWebp from './rbo.webp'
import rboPng from './rbo.png'
import { ArrowRightIcon } from '../Icon'
import { AdMark } from '../AdMark'
import { CardWrapper, ImgWrapper, Img, Title, SubTitle, Button } from '../styled'

export const RboCardComponent: FC = () => {
	const containerRef = useAdriverPixel(LandingNames.RBO_CARD)
	return (
		<CardWrapper ref={containerRef}>
			<ImgWrapper srcSource={rboWebp}>
				<Img src={rboPng} alt="" />
				<AdMark erid={AdMarkErid.RBO} tooltipId="rbo_ad_mark" />
			</ImgWrapper>
			<Title>Зарегистрировать бизнес и&nbsp;открыть расчетный&nbsp;счет</Title>
			<SubTitle>
				Оформите заявку без поездок в&nbsp;налоговую и&nbsp;откройте счет в&nbsp;банке
				с&nbsp;экономией для&nbsp;бизнеса
			</SubTitle>
			<Button
				type="primary"
				measure="l"
				text="Подробнее о регистрации бизнеса"
				onClick={() => addUrlParams(ProductNames.RBO, EridParam.RBO)}
			>
				<ArrowRightIcon />
			</Button>
		</CardWrapper>
	)
}
